import { timeFragment } from 'apollo/fragments';
import { workFlowFragment } from 'apollo/fragments/organization';
import { gql } from 'graphql.macro';

export const workFlowTemplate = gql`
    query workFlow {
        workFlow {
            ...workFlowFields
        }
    }
    ${workFlowFragment}
`;

export const workflowOverviewIncomingTemplate = gql`
    query workflowOverviewIncoming {
        workflowOverviewIncoming {
            noOfActions
            noOfConstructions
            noOfOrders
        }
    }
`;

export const workflowOverviewProductionTemplate = gql`
    query workflowOverviewProduction {
        workflowOverviewProduction {
            noStep {
                noOfActions
                noOfConstructions
                noOfOrders
            }
            stepOrders {
                name
                noOfActions
                noOfConstructions
                noOfOrders
                pausedOrders
                stepId
            }
        }
    }
`;

export const workflowOverviewAdministrationTemplate = gql`
    query workflowOverviewAdministration {
        workflowOverviewAdministration {
            productionOngoing {
                noOfOrders
                noOfActions
                noOfConstructions
            }
            productionFinished {
                noOfReadyForInvoice
                noOfOrders
                noOfActions
                noOfConstructions
            }
        }
    }
`;

export const orderWorkflowTemplate = gql`
    query orderWorkflow($orderId: MongoDbObjectId!) {
        orderWorkflow(orderId: $orderId) {
            stepLogs {
                _id
                stepId
                name
                comment
                dateTime
                isPaused
                pauseReason
                maxHourInStep
                user {
                    _id
                    fullName
                }
                externalTechnicians {
                    _id
                    fullName
                }
                workStarted
                timeSpent {
                    ...timeFields
                }
                timeWaiting {
                    ...timeFields
                }
                timeProduction {
                    ...timeFields
                }
                totalPauseTime {
                    ...timeFields
                }
                pauseLog {
                    type
                    dateTime
                    comment
                    reason
                    createdBy {
                        _id
                        fullName
                    }
                }
                automation {
                    type
                    status
                    subOrder {
                        _id
                        orderId
                    }
                }
            }
        }
    }
    ${timeFragment}
`;

export const subcontractStatusRulesTemplate = gql`
    query subcontractStatusRules {
        subcontractStatusRules {
            supplierId
            rules {
                status
                stepId
            }
        }
    }
`;

export const subcontractTriggerPendingTemplate = gql`
    query subcontractTriggerPending($orderId: MongoDbObjectId!) {
        subcontractTriggerPending(orderId: $orderId)
    }
`;

/** DD-3489: the lab's connected partners, for the per-partner rule editor. */
export const subcontractRulePartnersTemplate = gql`
    query subcontractRulePartners {
        suppliers {
            _id
            labId
            lab {
                _id
                name
            }
        }
    }
`;
